import React from "react";
// import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import "./PdfOpener.css";
import FileViewer from 'react-file-viewer';


const PdfOpener = ({ path = "", type }) => {
  const docs = [{ uri: path }];
  const uri = docs[0].uri;
  return (
    <div style={{ width: '100%', height: '100vh', padding: '20px' }}>
      <iframe
        src={`${uri}#navpanes=0`}
        title="PDF Viewer"
        width="100%"
        height="600px"
        style={{ border: 'none' }}
      />
    </div>
  );
};
export default PdfOpener;
